import { Box, Stack } from "@mui/material";
import ComingSoonFeature from "../../components/common/ComingSoonFeature";

const Sales = () => {
  return (
    <Box>
      <Stack spacing={4}>
        {/* Calendar Feature */}
        <Box>
          <ComingSoonFeature
            featureName="SALES"
            skeletonType="list"
            description="Advanced sales management and analytics coming soon!"
            height={650}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default Sales;
